import { FC, PropsWithChildren } from 'react'

const TwoLinesText: FC<PropsWithChildren> = ({ children }) => {
  return (
    <span className="line-clamp-2 block text-ellipsis whitespace-pre-wrap break-words text-left">
      {children}
    </span>
  )
}

export default TwoLinesText
